import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { validate, validators } from 'validate-redux-form';
import { FormatDate, maxFloatNumber } from '../../../../Utils/renderField/hookForms';
import { NumberField } from '../../../../Utils/renderField/fieldsHookForms';
import { Field, FieldArray, reduxForm, change } from 'redux-form';
import { renderSwitch } from '../../../../Utils/renderField/renderField';
import { api } from "api";
import { RenderDollar, RenderKilogramo } from '../../../../Utils/renderField/renderReadField';
import './BonifFletesForm.css';

/**
 * Componente para el paso de bonificación por costo de flete.
 * @param {object} props - Props del componente.
 * @returns {JSX.Element} - Componente de formulario de bonificación por costo de flete.
 */
let BonifFletesForm = props => {
    const { handleSubmit, previousStep } = props;
    const { control, formState: { errors }, watch, reset, trigger } = useForm();

    useEffect(() => {
        const historial_bonif_fletes = props.historial_bonif_fletes || [];

        if (historial_bonif_fletes.length <= 0) {
            api.get("finca_bonif_fletes/get_default_bonif_fletes").
                then((data) => {
                    props.dispatch(change('fincaForm', 'historial_bonif_fletes', data));
                }).catch(() => {
                    return [];
                });
        }
    }, [])

    const renderHistorial = (fieldArrayProps) => {

        const { fields, meta: { error, submitFailed } } = fieldArrayProps;
        const { bonif_fletes_min_kg, bonif_fletes_bono_por_kg } = watch();

        const AgregarRegistro = async () => {
            const camposValidos = await trigger();
            if (!camposValidos) return;

            const bonif_fletes_min_kg_float = parseFloat(bonif_fletes_min_kg.replace(",", ""));
            const bono_por_kilogramo_float = parseFloat(bonif_fletes_bono_por_kg.replace(",", ""));

            fields.push({
                bonif_fletes_min_kg: bonif_fletes_min_kg_float,
                bonif_fletes_bono_por_kg: bono_por_kilogramo_float,
                creado: new Date()
            });

            reset({
                bonif_fletes_min_kg: '',
                bonif_fletes_bono_por_kg: ''
            });
        }

        const historial = fields.getAll() ? [...fields.getAll()] : [];

        return (
            <div className=" col-sm-12 p-0">
                <div className="d-flex justify-content-center mt-2 mb-3">
                    <button type="button" className="btn btn-outline-info py-0" onClick={AgregarRegistro}>
                        AGREGAR
                    </button>
                </div>

                <h6 className="my-3">HISTORIAL DE CONFIGURACIÓN</h6>

                <div className="bonif-fletes-form__table-wrapper new-table-wrapper">
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th>FECHA</th>
                                <th className='th--right'>KILOGRAMOS MÍNIMOS</th>
                                <th className='th--right'>BONO POR KILOGRAMO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {historial.reverse().map((registro, index) => (
                                <tr key={index}>
                                    <td>
                                        {FormatDate(registro.creado)}
                                    </td>
                                    <td className='td--right td--no-wrap'>
                                        <RenderKilogramo value={registro.bonif_fletes_min_kg} />
                                    </td>
                                    <td className='td--right td--no-wrap'>
                                        <RenderDollar value={registro.bonif_fletes_bono_por_kg} decimalScale={4} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        )
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container bonif-fletes-form">
                <h6 className="mb-4">BONIFICACIÓN POR TRANSPORTE</h6>

                {/* Pregunta sobre bonificación */}
                <div className="formulario-fields-row">
                    <div className="formulario-field horizontal">
                        <label htmlFor="aplica_bonif_fletes">¿APLICA A BONIFICACIÓN POR TRANSPORTE?</label>
                        <Field name="aplica_bonif_fletes" component={renderSwitch} type="text" />
                    </div>
                </div>

                {/* Campos de valor límite NH3 y bono por kilogramo */}
                <div className="formulario-fields-row">
                    <div className="formulario-field">
                        <label htmlFor="bonif_fletes_min_kg" className="m-0">KILOGRAMOS MÍNIMOS</label>
                        <NumberField
                            control={control}
                            name="bonif_fletes_min_kg"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger('bonif_fletes_min_kg')}
                            suffix=" Kg"
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: 1, message: "Debe ser al menos 1" },
                                max: { value: maxFloatNumber, message: "El número es muy grande" },
                            }}
                        />
                    </div>
                    <div className="formulario-field">
                        <label htmlFor="bonif_fletes_bono_por_kg" className="m-0">BONO POR KILOGRAMO</label>
                        <NumberField
                            control={control}
                            name="bonif_fletes_bono_por_kg"
                            errors={errors}
                            allowNegative={false}
                            onEnterAction={() => trigger('bonif_fletes_bono_por_kg')}
                            prefix="$ "
                            rules={{
                                required: "Este campo es obligatorio",
                                min: { value: 0, message: "Debe ser al menos 0" },
                                max: { value: 1, message: "Debe ser menor o igual a 1" },
                            }}
                            decimalScale={4}
                        />
                    </div>
                </div>

                <FieldArray name="historial_bonif_fletes" component={
                    (fieldArrayProps) => renderHistorial(fieldArrayProps)
                } />

                {/* Botones */}
                <div className="buttons-box mt-3">
                    <button type="button" className="btn btn-outline-dark mx-3 mt-3 mb-2" onClick={previousStep}>ANTERIOR</button>
                    <button type="submit" className="btn btn-primary mx-3 mt-3 mb-2">SIGUIENTE</button>
                </div>
            </div>
        </form>
    );
};

BonifFletesForm = reduxForm({
    form: 'fincaForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: data => {
        return validate(data, {
            'nombre': validators.exists()('Campo requerido.'),
        })
    }
})(BonifFletesForm);


BonifFletesForm = connect(state => {
    const fincaForm = state.form.fincaForm;

    if (fincaForm && fincaForm.values) {
        const values = fincaForm.values;
        const { historial_bonif_fletes } = values;

        return {
            historial_bonif_fletes
        }
    } else {
        return {}
    }
})(BonifFletesForm)

export default BonifFletesForm
